import * as types from './types'
import * as getters from './getters'
import * as actions from './actions'

const state = {
  newsFound: [],
  selectedCategory: 0
}

const mutations = {
  [types.RECEIVE_SEARCH_NEWS] (state, data) {
    state.newsFound = data.newsSearch
  },
  [types.RECEIVE_SELECT_CATEGORY] (state, category) {
    state.selectedCategory = category
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/search/index.js